<template>
    <div>
    </div>
</template>

<script>
import { doc, getDoc } from 'firebase/firestore'
import { db } from '@/plugins/firebase'
import Sentry from '@/plugins/sentry'

async function getPlayerConfig (v) {
    if (v) {
        const docRef = doc(db, 'players', v)
        const docSnap = await getDoc(docRef)
        if (docSnap.exists()) {
            window.configPlayer = { ...docSnap.data() }
            return { ...docSnap.data() }
        } else {
            window.configPlayer = null
        }
    }
}

export default {
    name: 'getPlayerConfig',
    mounted () {
        window.getConfigPlayer = (v) => getPlayerConfig(v)
        // Config Sentry
        window.Sentry = Sentry
    }
}

</script>